/* Change this file to get your personal Portfolio */

// Website related settings
const settings = {
  isSplash: true, // Change this to false if you don't want Splash screen.
};

//SEO Related settings
const seo = {
  title: "Ratnesh's Portfolio",
  description:
    "A passionate embedded systems learner, bridging hardware and software through bare-metal and HAL-based firmware development on Arduino, ESP32, and STM32 — exploring RISC-V and ASCON to build secure, efficient, and future-ready embedded solutions.",
  og: {
    title: "Ratnesh Kumar Portfolio",
    type: "website",
    url: "https://16ratneshkumar.qzz.io/",
  },
};

//Home Page
const greeting = {
  title: "Ratnesh Kumar",
  logo_name: "RatneshKumar",
  nickname: "",
  subTitle:
    "A passionate Embedded Systems learner bridging hardware and software through firmware development. Exploring bare-metal & HAL programming on STM32, ESP32, RISC-V, and secure cryptography.",
  resumeLink: "Resume.pdf",
  portfolio_repository: "https://github.com/16ratneshkumar",
  githubProfile: "https://github.com/16ratneshkumar",
};

const socialMediaLinks = [
  /* Your Social Media Link */
  // github: "https://github.com/16ratneshkumar",
  // linkedin: "https://www.linkedin.com/in/16ratneshkumar/",
  // gmail: "jnvratneshkumar@gmail.com",
  // gitlab: "https://gitlab.com/16ratneshkumar",

  {
    name: "Github",
    link: "https://github.com/16ratneshkumar",
    fontAwesomeIcon: "fa-github ", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "Gitlab",
    link: "https://gitlab.com/16ratneshkumar",
    fontAwesomeIcon: "fa-gitlab ", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#FC6D26", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/16ratneshkumar/",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },
  {
    name: "Gmail",
    link: "mailto:jnvratneshkumar@gmail.com",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },
  {
    name: "Instagram",
    link: "https://www.instagram.com/16ratneshkumar/",
    fontAwesomeIcon: "fa-instagram", // Reference https://fontawesome.com/icons/instagram?style=brands
    backgroundColor: "#E4405F", // Reference https://simpleicons.org/?q=instagram
  },
];

const skills = {
  data: [
    {
      title: "Embedded Security",
      fileName: "SecurityImg",
      skills: [
        "⚡ Implementing lightweight cryptography using ASCON for resource-constrained devices",
        "⚡ Understanding secure firmware design principles for IoT and embedded systems",
        "⚡ Exploring hardware-software co-design for secure and efficient embedded solutions",
      ],
      softwareSkills: [
        {
          skillName: "ASCON",
          imageSrc: "ascon_logo.png",
        },
        {
          skillName: "C",
          fontAwesomeClassname: "devicon-plain:c",
          style: {
            color: "#A8B9CC",
          },
        },
        {
          skillName: "Rust",
          fontAwesomeClassname: "devicon-plain:rust",
          style: {
            color: "#000000",
          },
        },
        {
          skillName: "Assembly",
          fontAwesomeClassname: "simple-icons:assemblyscript",
          style: {
            color: "#007AAC",
          },
        },
        {
          skillName: "Linux",
          fontAwesomeClassname: "simple-icons:linux",
          style: {
            color: "#000000",
          },
        },
      ],
    },
    {
      title: "IoT & Communication Protocols",
      fileName: "IoTImg",
      skills: [
        "⚡ Interfacing sensors and peripherals using UART, SPI, and I2C communication protocols",
        "⚡ Building IoT-based systems using ESP32 with Wi-Fi and MQTT for real-time data exchange",
        "⚡ Designing embedded solutions that bridge physical hardware with cloud connectivity",
      ],
      softwareSkills: [
        {
          skillName: "ESP32",
          fontAwesomeClassname: "simple-icons:espressif",
          style: {
            color: "#E7352C",
          },
        },
        {
          skillName: "MQTT",
          fontAwesomeClassname: "simple-icons:mqtt",
          style: {
            color: "#660066",
          },
        },
        {
          skillName: "Wi-Fi",
          fontAwesomeClassname: "fa-wifi",
          style: {
            color: "#0078D4",
          },
        },
        {
          skillName: "Raspberry Pi",
          fontAwesomeClassname: "simple-icons:raspberrypi",
          style: {
            color: "#C51A4A",
          },
        },
        {
          skillName: "Linux",
          fontAwesomeClassname: "simple-icons:linux",
          style: {
            color: "#000000",
          },
        },
      ],
    },
    {
      title: "Embedded Systems & Firmware",
      fileName: "EmbeddedImg",
      skills: [
        "⚡ Developing bare-metal and HAL-based firmware for STM32, ESP32, and Arduino microcontrollers",
        "⚡ Writing low-level drivers and peripheral interfaces using C, C++, and assembly",
        "⚡ Exploring RISC-V architecture for efficient, open-standard embedded development",
      ],
      softwareSkills: [
        {
          skillName: "C",
          fontAwesomeClassname: "devicon-plain:c",
          style: {
            color: "#A8B9CC",
          },
        },
        {
          skillName: "C++",
          fontAwesomeClassname: "devicon:cplusplus",
          style: {
            color: "#00599C",
          },
        },
        {
          skillName: "STM32",
          fontAwesomeClassname: "simple-icons:stmicroelectronics",
          style: {
            color: "#03234B",
          },
        },
        {
          skillName: "Arduino",
          fontAwesomeClassname: "simple-icons:arduino",
          style: {
            color: "#00979D",
          },
        },
        {
          skillName: "ESP32",
          fontAwesomeClassname: "simple-icons:espressif",
          style: {
            color: "#E7352C",
          },
        },
        {
          skillName: "RISC-V",
          fontAwesomeClassname: "simple-icons:riscv",
          style: {
            color: "#283272",
          },
        },
      ],
    },
    {
      title: "Machine Learning & Deep Learning",
      fileName: "DataScienceImg",
      skills: [
        "⚡ Developing machine learning and deep learning models using Python",
        "⚡ Training machine learning models with PyTorch for hands-on AI projects",
        "⚡ Exploring neural networks, including transformer architectures, for modern AI",
        "⚡ Performing data analysis and visualization using Python, NumPy, Pandas, Matplotlib, and Seaborn",
      ],
      softwareSkills: [
        {
          skillName: "Python",
          fontAwesomeClassname: "devicon:python",
          style: {
            color: "#3776AB",
          },
        },
        {
          skillName: "PyTorch",
          fontAwesomeClassname: "devicon:pytorch",
          style: {
            color: "#EE4C2C",
          },
        },
        {
          skillName: "NumPy",
          fontAwesomeClassname: "devicon:numpy",
          style: {
            color: "#013243",
          },
        },
        {
          skillName: "Pandas",
          fontAwesomeClassname: "devicon:pandas",
          style: {
            color: "#150458",
          },
        },
        {
          skillName: "Matplotlib",
          fontAwesomeClassname: "devicon:matplotlib",
          style: {
            color: "#11557C",
          },
        },
        {
          skillName: "Jupyter",
          fontAwesomeClassname: "simple-icons:jupyter",
          style: {
            color: "#F37626",
          },
        },
      ],
    },
  ],
};

// Education Page
const competitiveSites = {
  competitiveSites: [
    {
      siteName: "EWskills",
      iconifyClassname: "",
      imageSrc: "ewskill_logo.png",
      profileLink: "https://www.ewskills.com/user/16ratneshkumar",
    },
    {
      siteName: "Codewars",
      iconifyClassname: "simple-icons:codewars",
      style: {
        color: "#b1361e",
      },
      profileLink: "https://www.codewars.com/users/16ratneshkumar",
    },
    {
      siteName: "HackerRank",
      iconifyClassname: "simple-icons:hackerrank",
      style: {
        color: "#2EC866",
      },
      profileLink: "https://www.hackerrank.com/profile/jnvratneshkumar",
    },

    {
      siteName: "HackerEarth",
      iconifyClassname: "simple-icons:hackerearth",
      style: {
        color: "#323754",
      },
      profileLink: "https://www.hackerearth.com/@16ratneshkumar/",
    },
    {
      siteName: "Kaggle",
      iconifyClassname: "simple-icons:kaggle",
      style: {
        color: "#20BEFF",
      },
      profileLink: "https://www.kaggle.com/ratneshkumar16",
    },
  ],
};

const degrees = {
  degrees: [
    {
      title: "Udacity",
      subtitle: "Future AI Programmer Nanodegree (AWS AI & ML Scholarship)",
      logo_path: "udacityLogo.png",
      alt_name: "Udacity",
      duration: "Aug 2025 - Present",
      descriptions: [
        "⚡ Awarded a fully sponsored AWS AI & ML Scholarship to pursue the Future AI Programmer Nanodegree.",
        "⚡ Learned Python, Machine Learning, Deep Learning, gaining hands-on experience with libraries like NumPy, Pandas, Matplotlib, Seaborn, PyTorch, and scikit-learn.",
        "⚡ Applied AI techniques for data analysis, model development, and practical problem-solving.",
        "⚡ Completed project-based assessments to demonstrate proficiency in modern AI and Machine Learning workflows.",
      ],
      website_link: "https://www.udacity.com/",
    },
    {
      title: "Ramanujan College (University of Delhi)",
      subtitle: "B.Sc. (Hons) Computer Science with Research",
      logo_path: "ramanujanLogo.png",
      alt_name: "RCDU",
      duration: "2023 - Present",
      descriptions: [
        "⚡ Studying core Computer Science subjects including Data Structures, Algorithms, DBMS, Operating Systems, Computer System Architecture, AI, and Theory of Computation.",
        "⚡ Developed an interest in firmware development and low-level systems, exploring the interaction between hardware and software.",
        "⚡ Participated in the Pandit Deendayal Upadhyaya Research Project Scheme, gaining experience in research and technical problem-solving.",
        "⚡ Maintaining consistent academic performance while actively expanding technical skills through projects and continuous learning.",
      ],
      website_link: "https://ramanujancollege.ac.in/",
    },
    {
      title: "Jawahar Navodaya Vidyalaya, Jaffarpur Kalan",
      subtitle: "Senior Secondary (CBSE) – Science",
      logo_path: "jnvLogo.png",
      alt_name: "JNVJF",
      duration: "2022 - 2023",
      descriptions: [
        "⚡ Studied Physics, Chemistry, Mathematics, and Computer Science, building a strong foundation in science and technology.",
        "⚡ Gained discipline, independence, and teamwork through the residential learning environment.",
        "⚡ Participated in NCC activities, developing leadership and responsibility.",
        "⚡ Represented my school in Kho Kho, improving teamwork and perseverance.",
      ],
      website_link:
        "https://navodaya.gov.in/nvs/nvs-school/SOUTH-WEST-DELHI/en/home/",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "AWS AI Practitioner Challenge",
      subtitle: "- Udacity",
      logo_path: "udacityLogo.png",
      certificate_link:
        "https://drive.google.com/file/d/125bDmFTQMqvAnqZ7ZPouzwtc0qBMN4k4/view?usp=sharing",
      alt_name: "Udacity",
      color_code: "#89adeeff",
    },
    {
      title: "Embedded System Essentials",
      subtitle: "- Jehan Daftari",
      logo_path: "embedded.png",
      certificate_link:
        "https://drive.google.com/file/d/1kwdgw43DwWGfk3Wz6r4GWrdthjT8TqVd/view?usp=sharing",
      alt_name: "BITS Pilani",
      color_code: "#ffffffff",
    },
    {
      title: "MicroPython for Beginners",
      subtitle: "- Saritha",
      logo_path: "upythonWithMicro.png",
      certificate_link:
        "https://drive.google.com/file/d/1wyQB9PfC399y9v-Csb7Tv-czZrdkGLSW/view?usp=sharing",
      alt_name: "NIELIT Calicut",
      color_code: "#f8f5f4ff",
    },
    {
      title: "Embedded for Beginners",
      subtitle: "- Saritha",
      logo_path: "nielit.png",
      certificate_link:
        "https://drive.google.com/file/d/1Eys9sLSEfi6ubNSziX_bBtJ9dIlI7iTl/view?usp=sharing",
      alt_name: "NIELIT Calicut",
      color_code: "#40e5ebaf",
    },
    {
      title: "GIT for Beginners",
      subtitle: "- Lydia Hallie",
      logo_path: "kkLogo.png",
      certificate_link:
        "https://learn.kodekloud.com/certificate/f122dada-a240-4eff-a753-afd89544fddd",
      alt_name: "Git",
      color_code: "#31b2ee99",
    },
    {
      title: "Rust Programming",
      subtitle: "- Priyanka Yadav",
      logo_path: "rustLogo.png",
      certificate_link:
        "https://learn.kodekloud.com/certificate/eb2c2f42-9f3a-405a-8446-dbf18c4be6d8",
      alt_name: "KodeKloud",
      color_code: "#0c0c0cd2",
    },
    {
      title: "OpenCV Bootcamp",
      subtitle: "- OpenCV University",
      logo_path: "opencvLogo.png",
      certificate_link:
        "https://courses.opencv.org/certificates/e7859017749043619212c72022e91241",
      alt_name: "OpenCV",
      color_code: "#0C9D5899",
    },
    {
      title: "Python For Beginners",
      subtitle: "- OpenCV University",
      logo_path: "opencvLogo.png",
      certificate_link:
        "https://courses.opencv.org/certificates/67ab7c66c53e401b8268057e7636f96c",
      alt_name: "Python",
      color_code: "#1F70C199",
    },
    {
      title: "Postman API Fundamentals Student Expert",
      subtitle: "- Kim Akers",
      logo_path: "postmanLogo.png",
      certificate_link:
        "https://badgr.com/public/assertions/2q_qEj-CSJG7sXPPB_LaNQ",
      alt_name: "Postman",
      color_code: "#f3945caf",
    },
  ],
};

// Achievement Page
const achievementSection = {
  title: "Awards & Activities",
  subtitle: "NCC, Sports and Hackathons",
  description:
    "Alongside my academic pursuits, I actively participate in extracurricular activities including NCC, Sports, and Hackathons, which have strengthened my leadership, teamwork, discipline, and problem-solving abilities — contributing to both my personal growth and professional development.",
  achievementsCards: [
    {
      heading: "National Cadet Corps",
      description: "",
      Section: [
        {
          image: "Ncc.png",
          alt_name: "NCC Logo",
          title: "NCC 'C' Certificate",
          subtitle: "Elite Leadership & Officer-Level Military Training.",
          footerLink: [
            {
              name: "View Certificate",
              url:
                "https://drive.google.com/file/d/1wyQB9PfC399y9v-Csb7Tv-czZrdkGLSW/view?usp=sharing",
            },
          ],
        },
        {
          image: "Ncc.png",
          alt_name: "NCC Logo",
          title: "NCC 'B' Certificate",
          subtitle: "Advanced Leadership & Military Skills.",
          footerLink: [
            {
              name: "View Certificate",
              url:
                "https://erp.ramanujancollege.ac.in/public/export_internal_data_subjectwise",
            },
          ],
        },
        {
          image: "Ncc.png",
          alt_name: "NCC Logo",
          title: "NCC 'A' Certificate",
          subtitle: "Building Discipline, Character & Leadership.",
          footerLink: [
            {
              name: "View Certificate",
              url:
                "https://drive.google.com/file/d/1DyhUfzkxyxnjuz33pkJwhNO0EkDDqSfz/view?usp=sharing",
            },
          ],
        },
      ],
    },
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Work, Internship and Volunteering",
  description:
    "I have worked on embedded systems projects as a Firmware Developer and Embedded Software Engineer, focusing on bare-metal programming and lightweight cryptography.",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Fellowship",
      work: true,
      experiences: [
        {
          title: "Data Science Intern",
          company: "Ramanujan College",
          company_url: "https://ramanujancollege.ac.in/",
          logo_path: "ramanujanLogo.png",
          duration: "June 2025 - March 2026",
          location: "Work From Home",
          description:
            "Worked on Data Science and Machine Learning solutions, developing supervised learning and LSTM neural network models for time-series data analysis and forecasting.",
          color: "#0071C5",
        },
      ],
    },
    {
      title: "Volunteering",
      experiences: [
        {
          title: "Developer Program Member",
          company: "Github",
          company_url: "https://github.com/",
          logo_path: "githubLogo.png",
          duration: "July 2024 - Present",
          location: "Work From Home",
          description:
            "Actively contributing to open-source projects across various organizations on GitHub, participating in bug fixes, feature additions, and documentation.",
          color: "#181717",
        },
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "My projects leverage a diverse range of modern embedded systems tools and technologies. My best experience lies in developing firmware and low-level embedded solutions using C and Rust, integrating hardware peripherals and communication protocols to build efficient and practical real-world systems.",
  avatar_image_path: "projectsImage.svg",
};

const publicationsHeader = {
  title: "Publications",
  description: "Some of my published Articles, Blogs and Research.",
  avatar_image_path: "projectsImage.svg",
};

const publications = {
  data: [
    // {
    //   id: "dummy-paper-1",
    //   name: "Lightweight Cryptography on Resource-Constrained Devices using ASCON",
    //   createdAt: "2025-11-15T00:00:00Z",
    //   description:
    //     "Research & Implementation of ASCON AEAD cipher for low-power microcontrollers.",
    //   url: "https://github.com/16ratneshkumar",
    // },
    // {
    //   id: "dummy-paper-2",
    //   name: "Optimizing Bare-Metal Firmware for Battery-Powered IoT Sensors",
    //   createdAt: "2025-08-20T00:00:00Z",
    //   description:
    //     "A study of power-aware scheduling and memory management techniques in embedded C firmware.",
    //   url: "https://github.com/16ratneshkumar",
    // },
  ],
};

// Big / Featured Projects Section
const bigProjects = {
  title: "Featured Projects",
  subtitle: "Some of my prominent projects and solutions",
  projects: [
    {
      image: "codeInLogo.png",
      title: "Transformers for Movie Review Sentiment Analysis",
      description:
        "Binary sentiment classification of movie reviews using transformer models with PyTorch and Hugging Face. Built for the Udacity AI Programming with Python Nanodegree.",
      link: "#",
    },
    {
      image: "codeInLogo.png",
      title: "Dog Breed Classifier",
      description:
        "A Python and PyTorch project benchmarking VGG16, ResNet18, and AlexNet pretrained CNNs to detect dog breeds and compare model accuracy. Built for the Udacity AI Programming with Python Nanodegree.",
      link: "https://github.com/16ratneshkumar/Dog-Breed-Classifier",
    },
  ],
};

// Talks & Workshops Section
const talkSection = {
  title: "TALKS",
  subtitle: "Some of my talks and workshops",
  talks: [
    // {
    //   title: "Bare-Metal STM32 Development",
    //   subtitle:
    //     "Hands-on workshop covering low-level driver development, register manipulation, and memory management.",
    //   slides_url: "https://github.com/16ratneshkumar",
    //   event_url: "https://github.com/16ratneshkumar",
    //   image: "experience.svg",
    // },
  ],
};

// Podcast Section
const podcastSection = {
  title: "Podcast 🎙️",
  subtitle: "Some of my podcasts and episodes",
  podcast: [
    // "https://open.spotify.com/embed/episode/example-1",
    // "https://open.spotify.com/embed/episode/example-2",
  ],
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "ratnesh.png",
    description:
      "I'm active on most social media platforms and reply within 24 hours. I'm passionate about low-level programming, and always open to collaborating, sharing knowledge, and exploring new ideas in the embedded and IoT space.",
  },
  blogSection: {
    title: "Blogs",
    subtitle:
      "I like to document my embedded systems journey — sharing firmware insights, low-level programming experiences, and technical knowledge gained through projects and academic exploration.",
    link: "https://blog.16ratneshkumar.qzz.io",
    avatar_image_path: "blogsImage.svg",
  },
  addressSection: {
    title: "Address",
    subtitle:
      "Raksha Enclave Extension, Vikas Nagar, Razapur Khurd, New Delhi, Delhi, 110059",
    locality: "Mohan Garden",
    country: "India",
    region: "New Delhi",
    postalCode: "110059",
    streetAddress: "Raksha Enclave Extension",
    avatar_image_path: "addressImage.svg",
    location_map_link: "https://maps.app.goo.gl/FTDvMbm8Fy4S7vmc8",
  },
  phoneSection: {
    title: "",
    subtitle: "",
  },
};

export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  publicationsHeader,
  publications,
  contactPageData,
  achievementSection,
  talkSection,
  podcastSection,
  bigProjects,
};
